// extracted by mini-css-extract-plugin
export default {"tabContent":"LeftSideBarNew_tabContent__JsM5w","tabContentActive":"LeftSideBarNew_tabContentActive__JOQ9k","slideIn":"LeftSideBarNew_slideIn__pD4MV"};